import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscriber',
  templateUrl: './subscriber.component.html',
  styles: [
  ]
})
export class SubscriberComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
